import { PeopleOutline } from '@mui/icons-material';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

/**
 * Shows the first party name plus a "+N" count, with every name in a hover/focus tooltip.
 * Renders nothing when there are no names so cards without party data keep their normal layout.
 */
export function PartyNamesDetail({ label, names }: {
  label: string;
  names?: string[];
}) {
  if (!names?.length) return null

  const [firstName, ...otherNames] = names
  const allNames = names.join(', ')

  return (
    <Tooltip
      arrow
      title={
        <Box component="ul" sx={{ m: 0, pl: 2 }}>
          {names.map((name, index) => <li key={`${index}-${name}`}>{name}</li>)}
        </Box>
      }
    >
      <Box
        tabIndex={0}
        role="group"
        aria-label={`${label}: ${allNames}`}
        sx={{ display: 'flex', alignItems: 'center', mt: 2, minWidth: 0 }}
      >
        <Box mr={1} sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>
          <PeopleOutline color="primary" aria-hidden="true" />
        </Box>
        <Stack sx={{ lineHeight: '10px', minWidth: 0 }} aria-hidden="true">
          <Typography variant="light" fontSize="12px">
            {label}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'baseline', minWidth: 0 }}>
            <Typography noWrap>{firstName}</Typography>
            {otherNames.length > 0 && (
              <Typography component="span" color="primary" sx={{ ml: 0.5, flexShrink: 0, fontWeight: 500 }}>
                +{otherNames.length}
              </Typography>
            )}
          </Box>
        </Stack>
      </Box>
    </Tooltip>
  )
}
